import Home from './views/Home.vue';
import Login from './views/Login.vue';
import CreateProject from './views/CreateProject';
import ProjectDetail from './views/ProjectDetail';
import Article from './views/Article';

const routes = [
  {
    path: '/projects/create',
    name: 'CreateProject',
    component: CreateProject,
  },
  {
    path: '/projects/:projectId',
      name: 'ProjectDetail',
    component: ProjectDetail,
    props: true
  },
  {
    path: '/articles/:articleId',
    name: 'Article',
    component: Article,
    props: true
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      layout: 'login',
      withoutAuth: true,
    }
  }
];

export default routes;


